import Tapper from "../images/homePage/tapper.png";
import Painter from "../images/homePage/painter.jpeg";

const images = [
    Tapper,
    Painter
]

export default images;